import React from 'react';
import { Link } from '@fiverr-private/typography';
import { FiverrDarkLogo } from '@fiverr-private/visuals';
import pathfinder from '@fiverr-private/pathfinder';
import { TOP_NAV_SOURCE } from '../../../constants';

export const FiverrLogoLink = () => {
    const url = pathfinder('root', {}, { query: { source: TOP_NAV_SOURCE } });

    return (
        <Link href={url} maxHeight="34px">
            <FiverrDarkLogo size="sm" />
        </Link>
    );
};
